import React, { Component, Fragment } from 'react';
import { Input, Select } from 'antd';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { checkNameFormat } from '@/services/helper/nameFormatCheck';
import { CAP, COMP_REPEATER, CONNECTOR, DIODE, IC, IND, RES } from '../../../../../constants/componentType';
import UnitAddonAfter from '../../../../../components/UnitAddonAfter';
import { checkRLCValue, numberCheck } from '../../../../../services/helper/dataProcess';
import { splitValueUnit } from '../../../../../services/helper/RLCValue';
import { RLC_TYPES } from '../../../../../services/PCBHelper';
import { getDefaultPreRLCValueByType, getDefaultPreRLCPreFixByType, getRLCTitle, splitPreLayoutNet } from '../../../../../services/Sierra/prelayout/Schematic';
import { getDefaultName } from '../../../../../services/helper/setDefaultName';
import sierraLibrary from '../../../../../services/Sierra/library/libraryStorage';
import { GENERIC_SPICE, PASSIVE_SPICE } from '../../../../../constants/libraryConstants';
import { DiodeModelSectionContent } from '../../PinToPinSetting/diodeModelSelection';
import _ from "lodash";
import RepeaterModelSelection from '../../modelSelection/repeaterModelSelection';
import '@/publicCss/style.css';
import '@/publicCss/aurora.css';
import './index.css';

const RLC_INPUT = [{ key: "value", title: "Value" }, { key: "voltage", title: "Voltage" }]
const UNITS = {
  r: [{ title: 'mΩ', key: "m" }, { title: 'Ω', key: "1" }, { title: 'KΩ', key: 'K' }, { title: 'MΩ', key: 'M' }],
  l: [{ title: 'pH', key: "p" }, { title: 'nH', key: "n" }, { title: 'uH', key: 'u' }, { title: 'H', key: '1' }],
  c: [{ title: 'pF', key: "p" }, { title: 'nF', key: "n" }, { title: 'uF', key: 'u' }, { title: 'F', key: '1' }]
}

class CompInfoPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      type: "",
      value: "",
      unit: "1",
      voltage: "",
      model: {},
      error: [],
      compInfo: {},
      repeaterModel: {},
      genericSpiceList: sierraLibrary.getTree(GENERIC_SPICE) || [],
      passiveSpiceList: sierraLibrary.getTree(PASSIVE_SPICE) || [],
      isUpdate: false
    };
    this.dialogRoot = document.getElementById(`pre-layout-schematic-${props.id}`);
  }

  componentDidMount = () => {
    this.initComp()
    this.props.changeOpenCompStatus()
  }

  componentDidUpdate = (prevProps) => {
    const { openedCompUpdate, libraryTreeInfo } = this.props;
    const isCompUpdate = openedCompUpdate && openedCompUpdate !== prevProps.openedCompUpdate;
    if (prevProps.comp && isCompUpdate) {
      this.saveComp(true)
      this.initComp()
    }
    isCompUpdate && this.props.changeOpenCompStatus();
    if (libraryTreeInfo && libraryTreeInfo.length && (!prevProps.libraryTreeInfo || libraryTreeInfo.length !== prevProps.libraryTreeInfo.length || !_.isEqual(prevProps.libraryTreeInfo || [], libraryTreeInfo || []))
      && (libraryTreeInfo.includes(PASSIVE_SPICE) || libraryTreeInfo.includes(GENERIC_SPICE))) {
      this.getLibraryList();
      this.props._updateLibraryTree(null);
    }
  }

  getLibraryList = () => {
    this.setState({
      genericSpiceList: sierraLibrary.getTree(GENERIC_SPICE) || [],
      passiveSpiceList: sierraLibrary.getTree(PASSIVE_SPICE) || []
    })
  }

  initComp = () => {
    const { comp = {} } = this.props;
    const { value, unit } = this.initValue(comp);
    const repeaterModel = this.getRepeaterModel(comp);
    this.setState({
      name: comp.name,
      type: comp.type,
      value,
      unit,
      voltage: comp.voltage,
      compInfo: JSON.parse(JSON.stringify(comp)),
      model: comp.model || {},
      repeaterModel,
      isUpdate: true
    })
  }

  getRepeaterModel = (comp) => {
    if (comp.type !== COMP_REPEATER) {
      return {}
    }
    const model = comp.model || {};
    const { components, signals } = this.props;
    let repeaterModel = { files: JSON.parse(JSON.stringify(model.files || [])), pinList: [], type: model.type };
    const findComp = components.find(item => item.name === comp.name);
    const pins = findComp.pins || [];
    for (let signal of signals) {
      const findPins = pins.filter(item => item.signal === signal.name);
      if (!findPins.length || findPins.length < 2) {
        continue
      }

      let inputPin = findPins[0].pin, outputPin = findPins[1].pin;
      //scl；input,scl_1:output; scl1；input,scl_2:output;

      const { num: firstNum } = splitPreLayoutNet(findPins[0].net || "", signal.name);
      const num1 = parseInt(firstNum ? firstNum : 0);

      const { num: secondNum } = splitPreLayoutNet(findPins[1].net || "", signal.name);
      const num2 = parseInt(secondNum ? secondNum : 0);

      if (num1 > num2) {
        inputPin = findPins[1].pin;
        outputPin = findPins[0].pin
      }

      const inputPair = (model.pairs || []).find(item => item.pin === inputPin) || {},
        outputPair = (model.pairs || []).find(item => item.pin === outputPin) || {};
      repeaterModel.pinList.push({
        input: {
          pin: inputPin || "",
          node: inputPair.node || "",
          fileName: inputPair.fileName || "",
          modelKey: inputPair.modelKey || "",
          subckt: inputPair.subckt || "",
          libraryId: inputPair.libraryId || ""
        },
        output: {
          pin: outputPin || "",
          node: outputPair.node || "",
          fileName: outputPair.fileName || "",
          modelKey: outputPair.modelKey || "",
          subckt: outputPair.subckt || "",
          libraryId: outputPair.libraryId || ""
        }
      })
    }

    return repeaterModel;
  }

  initValue = (comp) => {
    if (comp.type === CAP) {
      comp.value = comp.value || {};
      const { value: r, unit: rUnit } = splitValueUnit(comp.value.r || "");
      const { value: l, unit: lUnit } = splitValueUnit(comp.value.l || "");
      const { value: c, unit: cUnit } = splitValueUnit(comp.value.c || "");
      return {
        value: { r, l, c },
        unit: { r: rUnit || "1", l: lUnit || "1", c: cUnit || "1" }
      }
    } else {
      const valueObj = splitValueUnit(comp.value || "");
      return { value: valueObj.value, unit: valueObj.unit || "1" }
    }
  }

  saveComp = (isCompUpdate) => {
    const { name, type, value, unit, voltage, compInfo, error, namePrefix, model, repeaterModel } = this.state;
    if (error && error.length) {
      return;
    }
    let _comp = {
      prevName: compInfo.name,
      name,
      type,
      comps: [...(compInfo.comps || [])],
      model: model || {}
    }
    if (RLC_TYPES.includes(_comp.type)) {
      if (_comp.type === CAP) {
        _comp.value = {
          r: checkRLCValue(unit.r !== '1' ? `${value.r || 0}${unit.r}` : value.r || 0),
          l: checkRLCValue(unit.l !== '1' ? `${value.l || 0}${unit.l}` : value.l || 0),
          c: checkRLCValue(unit.c !== '1' ? `${value.c || 0}${unit.c}` : value.c || 0),
        }
      } else {
        const _value = unit !== '1' ? `${value || 0}${unit}` : value || 0;
        _comp.value = checkRLCValue(_value);
      }
      _comp.voltage = voltage;
    }

    if (_comp.type === DIODE) {
      _comp.voltage = voltage;
      _comp.model = model;
    } else if (_comp.type !== COMP_REPEATER) {
      delete _comp.model
    }
    if (_comp.type === COMP_REPEATER) {
      const pairs = (repeaterModel.pinList || []).map(item => { return [item.input, item.output] }).flat(2).filter(item => !!item.pin);
      _comp.model = { files: repeaterModel.files || [], pairs, type: repeaterModel.type };
    }

    if (!isCompUpdate) {
      this.setState({
        compInfo: _comp
      })
    }
    this.props.saveComp(_comp, _comp.comps, namePrefix, isCompUpdate)
  }

  close = () => {
    const { error } = this.state;
    if (error && error.length) {
      return;
    }
    this.saveComp();
    this.props.closePanel();
  }

  keyDown = (e) => {
    if (e.keyCode === 13) {
      e.target.blur();
    }
  }

  changeValue = (e, type, subType) => {
    const { error } = this.state;
    if (subType) {
      this.setState({
        [type]: { ...this.state[type], [subType]: e.target.value },
        error: error.filter(e => e.type !== subType)
      });
    } else {
      this.setState({
        [type]: e.target.value,
        error: error.filter(e => e.type !== type)
      });
    }

  }

  inputCheck = (type, subType) => {
    let check = null;
    if (type === "name") {
      const { components } = this.props;
      const { compInfo } = this.state;
      const value = this.state[type];
      check = checkNameFormat(value);
      if (!check) {
        const findComp = components.find(item => item.name === value && item.name !== compInfo.name);
        if (findComp) {
          check = "This name is already exist!";
        }
      }
    } else if (["value", "voltage"].includes(type)) {
      const value = this.state[type];
      let valueInput = value;
      if (subType) {
        valueInput = value[subType]
      }
      check = numberCheck(valueInput);
    }
    if (check) {
      this.setState({
        error: [
          ...this.state.error,
          { type: subType || type, error: check }
        ]
      })
    } else {
      this.saveComp()
    }
  }

  changeUnit = (key, subKey) => {
    if (subKey) {
      this.setState({
        unit: { ...this.state.unit || {}, [subKey]: key }
      })
    } else {
      this.setState({
        unit: key
      })
    }

  }

  selectChange = (value, type) => {
    const { components } = this.props;
    let { value: compValue, unit, name, type: compType, compInfo, voltage } = this.state;

    let prefix = null;
    if (RLC_TYPES.includes(compType)) {
      const findComp = components.find(item => item.name === compInfo.name) || {};
      const isPullUp = findComp && findComp.pins.length && findComp.pins.length === 1;
      const { value: defaultValue, unit: defaultUnit } = getDefaultPreRLCValueByType(value, isPullUp);
      compValue = defaultValue;
      unit = defaultUnit;
      const existComps = components.filter(it => name !== it.name).map(it => it.name);
      prefix = getDefaultPreRLCPreFixByType(value);
      /*   name = `${prefix}${nameNum}`; */
      name = getDefaultName({ nameList: existComps, defaultKey: prefix, key: "", firstIndex: 1 });
      if (compType === RES && [IND, CAP].includes(value)) {
        voltage = "0";
      }
      if (value === RES && [IND, CAP].includes(compType)) {
        voltage = "1.8";
      }
    }

    this.setState({
      [type]: value,
      value: compValue,
      unit,
      name,
      namePrefix: prefix,
      voltage
    }, () => {
      this.saveComp()
    })
  }

  nameRender = () => {
    const { name, compInfo } = this.state;
    return <div className="sierra-pre-layout-comp-info-item">
      <span>Name</span>
      <Input
        className="aurora-input"
        value={compInfo.comps && compInfo.comps.length ? compInfo.comps && compInfo.comps.join(", ") : name}
        disabled={compInfo.comps && compInfo.comps.length ? true : false}
        onChange={(e) => this.changeValue(e, "name")}
        onBlur={() => this.inputCheck("name")}
        onKeyDown={this.keyDown}
      />
    </div>
  }

  typeRender = () => {
    const { type } = this.state;
    const list = RLC_TYPES.includes(type) ? RLC_TYPES : [IC, CONNECTOR]
    return <Fragment>
      <div className="sierra-pre-layout-comp-info-item">
        <span>Type</span>
        <Select
          value={type}
          disabled={[DIODE, COMP_REPEATER].includes(type)}
          onChange={(key) => this.selectChange(key, "type")}
          className='aurora-select'
          popupClassName='aurora-select-dropdown'
          getPopupContainer={() => document.getElementById('root')}
          options={list.map(item => ({
            value: item,
            label: item
          }))}
        />
      </div>
    </Fragment>
  }

  valueRender = () => {
    const { unit, type, value, compInfo } = this.state;
    const { components } = this.props;
    const findComp = components.find(it => it.name === compInfo.name);
    if (![...RLC_TYPES, DIODE].includes(type)) { return }
    const filterKey = type === DIODE ? "voltage" : findComp && findComp.pins.length > 1 ? "value" : null
    const list = filterKey ? RLC_INPUT.filter(item => item.key === filterKey) : RLC_INPUT;
    return <Fragment>
      {list.map(item => (
        <Fragment key={item.key}>
          {type === CAP && item.key === "value" ?
            ["r", "l", "c"].map((it, i) => (
              this.getInput({
                title: i === 0 ? item.title : "",
                unit: unit[it],
                units: UNITS[it] || [],
                value: value[it],
                key: item.key,
                subKey: it,
                isValue: true,
                subTitle: getRLCTitle(it)
              })
            ))
            : this.getInput({
              title: item.title,
              unit,
              units: type === RES ? UNITS.r : (type === IND ? UNITS.l : []),
              value: this.state[item.key],
              key: item.key,
              isValue: item.key === "value"
            })}</Fragment>
      ))}
    </Fragment>
  }

  getInput = ({ title, unit, units, value, key, isValue = false, subKey, subTitle }) => {
    return <div className="sierra-pre-layout-comp-info-item" key={`${key}_${subKey || ""}`}>
      <span>{title}</span>
      <Input
        className="aurora-input"
        placeholder={subTitle || title}
        value={value}
        onChange={(e) => this.changeValue(e, key, subKey)}
        onBlur={() => this.inputCheck(key, subKey)}
        onKeyDown={this.keyDown}
        addonAfter={isValue ? UnitAddonAfter({
          unit,
          changeUnit: (unit) => this.changeUnit(unit, subKey),
          list: units
        }) : "V"}
      />
    </div>
  }

  onRef = (ref) => {
    this.modelRef = ref;
  }

  updateStatus = (isUpdate) => {
    this.setState({
      isUpdate
    })
  }

  updateModel = (model) => {
    this.setState({
      model
    }, () => {
      this.saveComp()
    })
  }

  updateRepeaterModel = (info, type) => {
    this.setState({
      repeaterModel: { ...this.state.repeaterModel, [type]: info }
    })
  }

  modelRender = () => {
    const { type, model = {}, genericSpiceList, passiveSpiceList, name, voltage, repeaterModel, isUpdate, libraryTreeInfo } = this.state;
    if (type === DIODE) {
      const { components } = this.props;
      const pins = (components.find(item => item.name === name) || {}).pins;
      const pin = pins && pins.length && pins[0] ? pins[0].pin : "";
      return <Fragment>
        <DiodeModelSectionContent
          model={model}
          pin={pin}
          isPower={voltage && !isNaN(voltage) && parseFloat(voltage) !== 0}
          passiveSpiceList={passiveSpiceList}
          genericSpiceList={genericSpiceList}
          isUpdate={isUpdate}
          updateStatus={this.updateStatus}
          updateModel={this.updateModel}
        />
      </Fragment>
    }


    if (type === COMP_REPEATER) {
      const { maxWidth, maxHeight } = this.props;
      return <RepeaterModelSelection
        onRef={this.onRef}
        isPreLayoutPage={true}
        files={repeaterModel.files}
        pinList={repeaterModel.pinList}
        modelFileType={repeaterModel.type}
        isUpdate={isUpdate}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        libraryTreeInfo={libraryTreeInfo}
        updateStatus={this.updateStatus}
        updateRepeaterModel={this.updateRepeaterModel}
      />
    }
  }

  render() {
    const { openElements, id } = this.props;
    const className = openElements ? "sierra-pre-layout-comp-info-ele-panel" : "";
    const { error, type } = this.state;
    const content = (
      <Panel
        className={`sierra-pre-layout-comp-info-panel sierra-panel ${className}`}
        title="Component Setup"
        zIndex={2000}
        width={type === COMP_REPEATER ? 454 : 300}
        minWidth={200}
        minHeight={200}
        position='panel-top-left'
        redirectDom={`pre-layout-schematic-${id}`}
        isRedirectDomId={true}
        onCancel={this.close}
        overflow='hidden'
        draggable
      >
        <div className={`sierra-pre-layout-comp-info-content ${type === COMP_REPEATER ? "sierra-pre-layout-comp-repeater-info-content" : ""}`}>
          {this.nameRender()}
          {this.typeRender()}
          {this.valueRender()}
          {this.modelRender()}
          {error && error[0] ? <span className='aurora-model-name-error-msg'>{error[0].error}</span> : null}
        </div>
      </Panel >)

    return createPortal(content, this.dialogRoot);
  }
}

export default CompInfoPanel;